import request from '@/utils/request'

export function sendSimpleMail(data) {
    return request({
        url: 'user/sendSimpleMail',
        method: 'post',
        data
    })
}